<div class="title"></div>

<div class="message">
    <p [innerHTML]="message"></p>
</div>

<div id="home-button">
    <app-button class="next" type="yellow-small" key="ui.bilan3.btn.home" (handler)="onHome()"></app-button>
</div>